import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagMA = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#D80027",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M39.774 20.517H28.488L25 9.783l-3.488 10.734H10.226l9.13 6.634-3.487 10.734L25 31.251l9.131 6.634-3.488-10.734 9.131-6.634Zm-17.861 5.804 1.179-3.63h3.816l1.18 3.63L25 28.564l-3.087-2.243Zm4.29-5.804h-2.405l1.202-3.7 1.202 3.7Zm3.734 4.46-.743-2.286h3.89l-3.147 2.286Zm-9.13-2.286-.744 2.286-3.146-2.286h3.89Zm-.803 9.503 1.202-3.7 1.945 1.414-3.147 2.286Zm6.845-2.286 1.945-1.413 1.202 3.699-3.147-2.286Z"
}));
FlagMA.displayName = 'FlagMA';
export default withFlagWrapper(FlagMA);
//# sourceMappingURL=index.js.map